import { Expression } from './Expression.js';
export class InvariantExpression extends Expression {
    constructor(oclExpression, name) {
        super();
        this.name = name || 'anonymous';
        this.definition = oclExpression;
    }
    getName() {
        return this.name;
    }
    getDefinition() {
        return this.definition;
    }
    evaluate(visitor, localVariables) {
        return this.getDefinition()
            .evaluate(visitor, localVariables);
    }
}
//# sourceMappingURL=InvariantExpression.js.map